// Verrou de défilement pour les popups/modales.
// Le site utilise Lenis (défilement fluide) qui pilote window.scrollTo en continu
// via sa propre boucle — un simple « overflow: hidden » sur body/html ne l'arrête
// PAS : la molette d'un popup défilait la page en arrière-plan. Il faut stopper
// Lenis le temps du popup, et marquer le conteneur défilable du popup avec
// data-lenis-prevent pour que Lenis ignore ses événements de molette.
//
// Le verrou est COMPTÉ : il supporte les popups imbriqués (ex. visionneuse photo
// ouverte par-dessus la fiche produit) — le défilement ne repart que lorsque le
// dernier popup se ferme.

let count = 0;

// Appelé à l'ouverture d'un popup : gèle le défilement de la page (Lenis + CSS).
export function lockScroll() {
  count += 1;
  if (count > 1) return;
  window.__lenis?.stop();
  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
}

// Appelé à la fermeture : restaure le défilement normal (dernier popup fermé).
export function unlockScroll() {
  count = Math.max(0, count - 1);
  if (count > 0) return;
  window.__lenis?.start();
  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
}
